import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ErrorsEnum from '../../constant/ErrorsEnum';
import { setSubscriber } from '../../LocalCellularTroubleshootingWizardBlockSlice';
import { startTroubleshootingWizard , goToPageAsync } from '../../LocalCellularTroubleshootingWizardBlockThunk';
import SelectSubscriber from 'app/Components/Shared/SelectSubscriber/SelectSubscriber';

const SubscribersPage = (props) => {

    function handleOnSubscriberSelect(subscriber){
        const banId = props.selfcareCellularProducts?.find( x => x.productSubscriberNo == subscriber)?.ban;
        props.setSubscriber({subscriber : subscriber , ban: banId });
    }

    function initWizard(subscriber){
        if(subscriber){
          const banId = props.selfcareCellularProducts?.find( x => x.productSubscriberNo == subscriber)?.ban;
          props.setSubscriber({subscriber : subscriber , ban: banId });
        }
        props.startTroubleshootingWizard();
    }

    function handleOnNoSubscriberAction(){
        props.goToPageAsync({pageType: ErrorsEnum.NO_CELLULAR_SUBSCRIBER });
    }

  return (
      <div className='subscribers-page'>
        <SelectSubscriber title={'עם איזה מנוי להתקדם?'}  onSubscriberSelect={handleOnSubscriberSelect} onOneSubscriberAction={initWizard} onSubmit={initWizard} onNoSubscriberAction={handleOnNoSubscriberAction} />
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
     selfcareCellularProducts : state.selfcarePage.subscribersByProduct?.Cellular
  };
};

const mapDispatchToProps = { setSubscriber , startTroubleshootingWizard , goToPageAsync};

export default connect(mapStateToProps, mapDispatchToProps)(SubscribersPage);
